import React, { useEffect, useState } from "react";
import { FieldArray, Form, FormikProvider, useFormik } from "formik";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Chip,
  Stack,
  TextField,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import { updateRestartDate } from "../../../../redux/features/batchSlice";
import { Icon } from "@iconify/react/dist/iconify.js";
import * as Yup from "yup";
import {
  getWorkFromHomeTasks,
  updateWFHTaskStatus,
} from "../../../../redux/features/leaveSlice";
import GlobalDialog from "../../../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../../../components/mui/GlobalSelectField";

const UpdatetaskStatus = ({ TaskID, status, disabled, leaveAppID }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading, wfhTasks } = useSelector((state) => state.leave);

  const validationSchema = Yup.object().shape({});

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      status: status || "",
      wfhtaskID: TaskID,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      dispatch(updateWFHTaskStatus(values)).then((res) => {
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          dispatch(
            getWorkFromHomeTasks({
              leaveAppId: leaveAppID,
              isHead: false,
            })
          );
          setOpen(false);
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
        }
      });
    },
  });

  const TaskStatusOptions = [
    { id: 0, label: "Not Started" },
    { id: 1, label: "Completed" },
    { id: 2, label: "In Progress" },
  ];

  return (
    <GlobalDialog
      title={"Update Task Status"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"xs"}
      closeButton={true}
      popupButton={
        <Button
          size="small"
          variant="contained"
          color="secondary"
          onClick={() => setOpen(true)}
          startIcon={
            <Icon icon={"dashicons:update-alt"} width={18} height={18} />
          }
        >
          Update Status
        </Button>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"}>
                  {disabled && (
                    <Alert severity="info" variant="outlined">
                      Reporting head not approved
                    </Alert>
                  )}
                  {!disabled && (
                    <GlobalSelectField
                      options={{
                        formik,
                        name: "status",
                        label: "Status",
                        data: TaskStatusOptions,
                        keys: {
                          id: "id",
                          value: "label",
                        },
                      }}
                    />
                  )}
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <Button
                      size="small"
                      variant="outlined"
                      color="secondary"
                      onClick={() => setOpen(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      disabled={loading || disabled}
                      variant="contained"
                      color="secondary"
                      size="small"
                      type="submit"
                    >
                      {loading ? "Please wait..." : "Save"}
                    </Button>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default UpdatetaskStatus;
